module.exports = "<div #body class=\"sb-item-body\" [style.height]=\"height\">\r\n    <div class=\"card-body\">\r\n    \t<ng-content></ng-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/accordion/components/sb-item.body.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/accordion/components/sb-item.body.html
// module chunks = main